'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _addClass = require('dom-helpers/class/addClass');

var _addClass2 = _interopRequireDefault(_addClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _elementType = require('react-prop-types/lib/elementType');

var _elementType2 = _interopRequireDefault(_elementType);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _safeAttributes = require('../utils/safeAttributes');

var _safeAttributes2 = _interopRequireDefault(_safeAttributes);

var _bootstrapUtils = require('../utils/bootstrapUtils');

var _createChainedFunction = require('../utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _tabUtils = require('../utils/tabUtils');

var _Fade = require('../Fade');

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabPane = function (_React$Component) {
  _inherits(TabPane, _React$Component);

  function TabPane() {
    _classCallCheck(this, TabPane);

    var _this = _possibleConstructorReturn(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).call(this));

    _this.getTransition = _this.getTransition.bind(_this);
    _this.getUnmountOnExit = _this.getUnmountOnExit.bind(_this);
    _this.isActive = _this.isActive.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.registerWithParent = _this.registerWithParent.bind(_this);
    _this.unregisterWithParent = _this.unregisterWithParent.bind(_this);
    return _this;
  }

  _createClass(TabPane, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.exited = !this.isActive();
      this.registerWithParent();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (nextProps.eventKey !== this.props.eventKey) {
        this.unregisterWithParent();
        this.registerWithParent(nextProps, nextContext);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, _, nextContext) {
      if (this.isActive(nextProps, nextContext)) {
        this.exited = false;
      } else if (!this.exited && !this.getTransition(nextProps, nextContext)) {
        // Otherwise let handleHidden take care of marking exited.
        this.exited = true;
        this._fireExitedCallback = true;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._fireExitedCallback) {
        this._fireExitedCallback = false;
        this.onExited();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregisterWithParent();
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return { $bs_tabcontainer: null };
    }
  }, {
    key: 'getTransition',
    value: function getTransition() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      var lcontext = this.getContext('$bs_tabcontent', context);
      return props.animation != null ? props.animation : lcontext.animation;
    }
  }, {
    key: 'getUnmountOnExit',
    value: function getUnmountOnExit() {
      var context = this.getContext('$bs_tabcontent', this.context);
      return this.props.unmountOnExit != null ? this.props.unmountOnExit : context.unmountOnExit;
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      return this.getContext('$bs_tabcontent', context).activeKey === props.eventKey;
    }
  }, {
    key: 'render',
    value: function render() {
      var active = this.isActive();
      var visible = active || !this.exited;
      var getId = this.getContext('$bs_tabcontainer').getId;
      var bsClass = this.props.bsClass || this.getContext('$bs_tabcontent').bsClass;

      var Transition = this.getTransition();

      if (!visible && !Transition && this.getUnmountOnExit()) {
        return null;
      }

      var classes = _defineProperty({
        active: visible
      }, (0, _bootstrapUtils.prefix)({ bsClass: bsClass }, 'pane'), true);

      var _props = this.props,
          id = _props.id,
          labelledBy = _props['aria-labelledby'];
      var _props2 = this.props,
          eventKey = _props2.eventKey,
          onExit = _props2.onExit,
          onExiting = _props2.onExiting,
          onExited = _props2.onExited,
          onEnter = _props2.onEnter,
          onEntering = _props2.onEntering,
          onEntered = _props2.onEntered;

      if (typeof Transition === 'boolean') {
        Transition = Transition ? _Fade2.default : null;
      }

      if (getId) {
        (0, _warning2.default)(!(id || labelledBy), 'In the context of a TabContainer, TabPanes are given generated `id` and `aria-labelledby` ' + 'attributes for the sake of proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` prop to the parent TabContainer.');
        id = getId(eventKey, _tabUtils.PANE) || null;
        labelledBy = getId(eventKey, _tabUtils.TAB) || null;
      }

      var tabPane = _react2.default.createElement(
        'div',
        _extends({}, (0, _safeAttributes2.default)(this.props), {
          id: id,
          role: 'tabpanel',
          'aria-hidden': !visible,
          'aria-labelledby': labelledBy,
          className: (0, _classnames2.default)(this.props.className, classes, { in: !Transition })
        }),
        this.props.children
      );

      if (Transition) {
        tabPane = _react2.default.createElement(
          Transition,
          {
            'in': active,
            onExit: onExit,
            onExiting: onExiting,
            onExited: (0, _createChainedFunction2.default)(this.handleExited, onExited),
            onEnter: (0, _createChainedFunction2.default)(this.handleEnter, onEnter),
            onEntering: onEntering,
            onEntered: onEntered,
            unmountOnExit: this.getUnmountOnExit()
          },
          tabPane
        );
      }

      return tabPane;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      var context = this.getContext('$bs_tabcontent');
      if (context.onExited) {
        context.onExited(this.props.eventKey);
      }
    }
  }, {
    key: 'handleEnter',
    value: function handleEnter(node) {
      // ref: https://github.com/react-bootstrap/react-overlays/issues/40
      if (this.isActive()) {
        (0, _addClass2.default)(node, 'active');
        node.offsetWidth; // eslint-disable-line no-unused-expressions
      }
    }
  }, {
    key: 'handleExited',
    value: function handleExited() {
      this.exited = true;
      this.onExited();
      this.forceUpdate();
    }
  }, {
    key: 'registerWithParent',
    value: function registerWithParent() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      var register = this.getContext('$bs_tabcontent', context).register;

      if (register) {
        this.unregister = register(props.eventKey);
      }
    }
  }, {
    key: 'unregisterWithParent',
    value: function unregisterWithParent() {
      if (this.unregister) {
        this.unregister();
      }
    }
  }, {
    key: 'getContext',
    value: function getContext(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      return context[key] || {};
    }
  }]);

  return TabPane;
}(_react2.default.Component);

TabPane.childContextTypes = {
  $bs_tabcontainer: _propTypes2.default.oneOf([null])
};

TabPane.contextTypes = {
  $bs_tabcontainer: _propTypes2.default.shape({
    getId: _propTypes2.default.func,
    unmountOnExit: _propTypes2.default.bool
  }),
  $bs_tabcontent: _propTypes2.default.shape({
    bsClass: _propTypes2.default.string,
    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
    activeKey: _propTypes2.default.any,
    onExited: _propTypes2.default.func,
    register: _propTypes2.default.func,
    unmountOnExit: _propTypes2.default.bool
  })
};

TabPane.propTypes = {

  /**
   * Uniquely identify the TabPane amoung its siblings.
   */
  eventKey: _propTypes2.default.any,

  /**
   * Use animation when showing or hiding TabPanes. Use `false` to disable,
   * `true` to enable the default "Fade" animation or any Transition component.
   *
   */
  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),

  /** @private **/
  id: _propTypes2.default.string,

  /** @private **/
  'aria-labelledby': _propTypes2.default.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: _propTypes2.default.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: _propTypes2.default.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: _propTypes2.default.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: _propTypes2.default.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: _propTypes2.default.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: _propTypes2.default.func,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: _propTypes2.default.bool
};

exports.default = (0, _bootstrapUtils.bsClass)('tab', TabPane);